var _style, _path, _linearGradient, _path2, _linearGradient2, _path3, _g, _path4, _g2, _path5, _use, _linearGradient3, _use2, _use3, _linearGradient4, _use4, _linearGradient5, _path6, _path7, _path8, _linearGradient6, _path9, _path10, _path11, _path12, _path13, _linearGradient7, _use5, _g3, _linearGradient8, _path14, _linearGradient9, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g4, _path23, _linearGradient10, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _use6, _linearGradient11, _use7, _g5, _linearGradient12, _path31, _g6, _linearGradient13, _use8, _path32, _linearGradient14, _path33, _path34, _use9, _linearGradient15, _use10, _path35, _path36, _g7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 480,
    height: 409.9,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#fc5b3f}.b{fill:#fff}.c{fill:#fcbdba}.d{fill:#473f47}.e{fill:#fdb9a9}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M470.5 275.8c-3.5 13.7-9.5 27.5-14.9 39.7-20.2 46.2-54.1 77.8-107.3 71.3-25.6-3.2-50.8-11.7-76.6-10.9-24.7.8-48.2 10.1-71.7 17.9-43.6 14.4-91.9 23.7-135 7.8s-76.5-64.8-61.2-108.1C15.7 259.7 53 237 57 201.3 62 155 7.2 115 18.8 69.8c4.9-19 20.7-33.2 37.5-43.4C94.9 2.8 142.2-5 186.4 3.1c42.1 7.6 77.2 43 119.6 44.6 27.4 1.1 53.7-14.5 80.9-11.9 33.7 3.3 58.5 33.1 74.2 63.1 5.1 9.4 9.3 19.1 12.7 29.3 6.5 20.5 7.9 42.5 3.8 63.7-4.1 21.8-3.6 42.2-4.2 64.6-.1 6.5-1.2 13-2.9 19.3z",
    opacity: 0.18,
    className: "a"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    gradientUnits: "userSpaceOnUse",
    x1: 202.75,
    y1: 328.526,
    x2: 205.571,
    y2: 382.746
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M178.5 364.1c-1.6.5-3.6 1.3-3.9 3 5.3 3.4 11.7 4.1 17.9 3.9 6.1-.2 12.4-1.2 18.5-1.2 8.2 0 17.4 1.4 24-3.5-2.9-1.8-6.2-2.9-9.7-3.1 1.2-7.6-41.9-.6-46.8.9z",
    fill: "url(#A)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    gradientUnits: "userSpaceOnUse",
    x1: 223.134,
    y1: 125.627,
    x2: 234.961,
    y2: 319.533
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5 273.2c-2.2 0-5.3 1.2-4.7 3.3l100.7 8.2c11.8 1 23.7 1.9 35.6 1.9 18 0 35.9-2.2 53.9-3.3 16.9-1 33.8-.9 50.7-.9 15.6.1 34.9 2.9 50.1-1.2 2.3-.6 4.6-2.5 4.4-4.8-.1-1.1-.7-2.2-.2-3.3.3-.5.7-.9 1.2-1.2 3.2-1.9 7.1-.4 10.7.4 5.8 1.2 11.7.5 16.9-2.1 1-.4 1.8-1.1 2.4-2s.4-2.1-.5-2.8a3.08 3.08 0 00-1.3-.3l-30.8-2.4c-1.2-.2-2.3-.1-3.4.3-1.2.6-1.2 1.9-2.1 2.5-1.6 1-5.2.5-7 .6l-14 .8-28 1.2-57.4 1.3-113.5 2.4c-21.3.8-42.5 1-63.7 1.4z",
    fill: "url(#B)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ff681c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.9 63.3c-1.7-.6-3.7-.6-5.5.1-2.3.8-4.1 2.5-5 4.8 0 .6-.5 1-1.1 1h-.1c-2 0-3.9.8-5.4 2-1.7 1.5-1.7 3.5-1.9 5.8a1.91 1.91 0 00-1.8 0c-.6.3-1.1.7-1.5 1.1-.8.6-1.3 1.3-1.7 2.2-.6 1.4.1 3.2.1 4.7 0 .1 0 .3-.1.4s-.3.1-.4 0c-.4-.1-.8-.3-1.2-.4-1.1 0-1.9.8-2.1 1.7-.2 1-.1 2 .2 3s.2 1.9-.1 2.9c-.3.6-.8 1.2-1.2 1.6-1.4 1.3-2.4 3.3-2.7 5.2-.1 1 .2 1.9.8 2.7s1.5 1.2 2.5 1.2c2.3-.3 3.1-3.5 5.2-4.2 2.1-.8 4.6-3.3 6-5.3 1.2-1.6 2.2-3.5 4.1-4.1.6-.1 1.2-.4 1.7-.7.4-.3.7-.7.9-1.1.8-1.2 1.3-2.4 1.8-3.7.7-2.6 0-5.6 1.2-8 .8-1.4 2-2.4 3.6-2.8.7-.2 1.3-.2 1.9-.4.8-.2 1.4-.6 2.1-1 1.6-1 2.9-2.6 3.2-4.5 0-1.8-1.7-3.6-3.5-4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.5 66.4c1.4.6 2.2 2 1.9 3.5-.2.6-.6 1.1-1.1 1.5l-2.5 2.7-1.1-3.7c-.1-.7-.5-1.3-1-1.8-.7-.4-1.6-.4-2.3 0-.8.4-1.3 1-2 1.3-.2.1-.4.2-.6.1s-.2-.5-.1-.8c1.3-3.1 5.8-4 8.8-2.8z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M158.2 169a8.1 8.1 0 001.2 3.6c1.1 1.3 3 2 4.5 3.1.3.2.6.5.7.8 0 .4-.2.7-.6.8-.3.1-.7.1-1 .1-1.5-.3-3.2-.4-4.7-.5-.8 0-1.7.1-2.2-.6-.3-.5-.5-1.2-.3-1.7.1-2.2 0-4.5-.6-6.7-.2-.6-.2-1.1-.2-1.6a1.51 1.51 0 011.7-1.2c.3.1.5.2.7.3 1 .6.7 2.5.8 3.6zm-25.2 8.4c-.2 1.2 0 2.6.5 3.7.8 1.6 2.5 2.6 3.7 3.8.3.2.5.6.5 1-.1.3-.4.6-.7.6s-.7 0-1-.1c-1.4-.6-3-1-4.5-1.3-.8-.1-1.7-.3-2-1-.2-.6-.2-1.2 0-1.7a25.17 25.17 0 00.9-6.7c-.1-.6 0-1.2.2-1.6.3-.8 1.2-1.2 2-.8.2.1.5.3.6.5.5.7-.1 2.6-.2 3.6z",
    className: "c"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128 116.1s13 19.3 21.5 25.1c-.2 1.9-.1 3.8.1 5.8.5 3.2 1.9 5.9 2.4 8.9l1.6 10.3c.1.5.2 1.1.7 1.2.3.1.6.1.9 0l3.6-1c-.2-6.2-.1-12.4.4-18.6.3-2.5.4-5 .2-7.5-.6-5.5-5.1-10.3-8.2-14.7-1.8-2.7-3.8-6.6-6.5-8.6-2.2-1.6-5.3-.9-8-.6-2 .2-4.1.1-6.1-.5-.8-.3-1.8-.3-2.6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.1 116s5.1 22.8 10.9 31.2c-.9 1.7-1.5 3.6-2 5.5-.3 1.5-.5 3.1-.6 4.7l-1.2 19c1.8.1 3.6-.1 5.4-.7l6.6-16.7c1.2-2.7 2-5.6 2.2-8.4 0-5.7-5.5-26.5-6-27.6-1.4-2.4-4.6-2.7-7.2-3.5-2-.6-3.8-1.4-5.6-2.7-.8-.6-1.6-1.1-2.5-.8z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M169.7 98.3c2.8 1.2 5.9 1.7 8.8 1.3.9-.3 1.8-.3 2.7-.1-.4.6-.8 1.3-.2 1.8.2.1.4.2.6.2.8.1 1.4 0 2.2-.2a1.39 1.39 0 011.1-.2c.7.2 1.1.9 1 1.5-.2.7-.6 1.2-1.2 1.5-1.9 1.2-4.3 1.4-6.3.4-.6-.3-1.1-.7-1.7-1.1-1.2-.5-2.3-.9-3.6-1.1-3.6-.8-7.1-1.7-10.6-3.1-1.1-.3-1.9-1-2.5-1.8-.7-1.7.6-4.6 2.6-3.5 2.4 1.5 4.6 3.4 7.1 4.4z",
    className: "c"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Q",
    className: "a"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    gradientUnits: "userSpaceOnUse",
    x1: 2922.544,
    y1: -1171.089,
    x2: 2901.704,
    y2: -1147.677,
    gradientTransform: "matrix(-.8343 .5901 .5901 .8343 3247.361 -663.838)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Q",
    fill: "url(#C)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#R",
    className: "a"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    gradientUnits: "userSpaceOnUse",
    x1: 224.441,
    y1: 192.65,
    x2: 106.296,
    y2: -47.24
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#R",
    fill: "url(#D)"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    gradientUnits: "userSpaceOnUse",
    x1: 158.046,
    y1: 89.507,
    x2: 170.31,
    y2: 149.655
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M158.2 116c3.4 2.7 6.8 5.7 10.9 6.3 1.6.4 3.3.1 4.6-.9.5-.3.8-.8.7-1.3-.2-.7-1-.9-1.6-1.1-3.2-.4-6.1-1.5-8.8-3.2-1-.7-1.9-1.4-2.8-2.3l-6.6-6c-.2-.2-.4-.3-.7-.3s-.5.3-.6.6c-.4.9-.8 1.7-1 2.6-.2 1 0 1.2.9 1.7 1.9 1.4 3.5 2.5 5 3.9z",
    fill: "url(#E)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M161.3 111c2.3 2 5.2 3.4 8.2 3.8.9 0 1.8.2 2.6.6-.6.4-1.2 1.2-.8 1.7.1.2.3.3.5.4.7.3 1.4.4 2.1.4.4-.1.8 0 1.1.1.6.4.8 1.2.5 1.7-.4.6-1 1-1.5 1.2a6.34 6.34 0 01-6.2-1.4l-1.3-1.4c-1-.8-2-1.4-3.1-2a60.71 60.71 0 01-9.3-5.9 3.98 3.98 0 01-1.9-2.5c-.2-1.8 1.8-4.2 3.5-2.6 1.9 1.8 3.5 4.1 5.6 5.9z",
    className: "c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M123.1 119c.3.3.6.5.9.7 1.3.8 2.8 1.4 4.2 2 3.8 1.3 8 1.3 11.8-.1 1.5-.6 3-1.3 4.2-2.3.5-.3.9-.8 1.2-1.2.4-.9.5-1.7.3-2.6-.4-4.6-.9-9.3 0-13.8.3-1.5.8-3 1.3-4.4 1.1-1.9 2-3.9 2.7-6 .5-2.6-.2-5.4-1.9-7.4-1.7-2.3-5-4.2-7.9-3.3-3.3 1.2-6.1 3.5-8.3 6.3-2.3 3.2-4 6.7-5.3 10.5-.6 1.4-1.1 2.9-1.5 4.4-.9 3.6-1.4 7.3-1.7 11-.2 1.5-.3 3.1-.5 4.7.1.3.2.9.5 1.5z",
    className: "a"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    gradientUnits: "userSpaceOnUse",
    x1: 2896.488,
    y1: -1139.545,
    x2: 2942.763,
    y2: -1137.053,
    gradientTransform: "matrix(-.8343 .5901 .5901 .8343 3247.361 -663.838)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M140 121.5c1.5-.6 3-1.3 4.2-2.3.5-.3.9-.8 1.2-1.2.4-.9.5-1.7.3-2.6-.4-4.6-.9-9.3 0-13.8-.6-.6-1.2-1.1-1.7-1.5-1.3-1.2-3.4-3.4-5.3-3.2a69.82 69.82 0 011.2 6.3c.3 2.1.2 4.3.5 6.4.5 3.7.4 7.5-.3 11.1 0 .4 0 .6-.1.8z",
    fill: "url(#F)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M156.6 103.8c.2.1.4.3.5.6 0 .2-.1.5-.2.6-1.2 1.7-2.8 3.3-4.6 4.4l-.6.3c-.3 0-.5-.1-.7-.3l-8.1-6.2c-1.7-1.2-3.3-2.7-4.5-4.4-1-1.5-1.6-3.2-2.1-4.9-1.6-5.1 3.3-7.3 6.5-3.6 4.4 4.8 8.3 9.6 13.8 13.5z",
    className: "a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M155.9 176.5c-.2-.4-.1-.8.1-1.1.3-.3.8-.2 1.2 0 .9.4 1.7.8 2.6 1 1 .3 1.9.1 2.7-.3.5-.3 1-.7 1.4-.7.3 0 .5.1.8.3.9.4 1.7.8 2.6.9.4 0 .8.2 1.1.4.1.1.2.2.2.3 0 .3-.3.5-.5.6-2.9 1.1-6 .7-9 .4H158c-.5.1-1.2.4-1.5 0a7.59 7.59 0 01-.6-1.8zm-26.9 7.7c-.1-.4 0-.8.3-1.1.4-.3.8 0 1.2.2.8.5 1.6 1 2.5 1.2a4.16 4.16 0 002.7 0c.5-.2 1-.6 1.5-.5.3.1.5.2.7.4.8.6 1.5 1 2.5 1.2.4.1.8.3 1.1.5.1.1.1.2.2.3 0 .3-.3.5-.6.5-3 .8-6 0-9-.8-.3-.1-.7-.2-1.1-.2-.5 0-1.2.2-1.5-.3-.4-.2-.5-.8-.5-1.4z",
    className: "d"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M154.3 75.8c-.2.8-.5 1.5-.7 2.3-.2 1.2-.5 2.3-.9 3.4s-1.2 2-2.3 2.4c-1.2.4-2.4-.2-2.8-1.3-.7.2-.9 1-.9 1.6.1.7 0 1.3-.4 1.9-.6.8-1.8.4-2.6-.1-2.5-1.6-3.7-4.7-3.2-7.6.7-3.1.7-6.7 2.4-9.3.6-.9 1.4-1.6 2.3-2.2.8-.6 1.7-1 2.7-1.1.7 0 1.3 0 2 .2 2.9.5 5.4 1 5.4 4.2 0 1.8-.3 3.8-1 5.6z",
    className: "c"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M150.7 70.5c-.5 0-1-.1-1.3.2s-.4.9-.7 1.3c-.5.9-1.7 1.1-2.6 1.4-1.2.6-1.8 1.8-1.8 3.1 0-.4-.1-.8-.3-1.2a.78.78 0 00-1-.2c-.1.2-.2.3-.2.5-.1.8.3 1.5.9 2-.6 1.2-1.8 1.9-3.2 1.9a1.92 1.92 0 01-1.2-.4c-.2-.2-.4-.5-.5-.8-.8-2.2.4-4.5.7-6.8 0-.8.2-1.6.4-2.4.3-.6.6-1.1 1.1-1.4 1.2-1.5 3-2.7 4.9-3.3 1.8-.5 5.5-.3 6.9 1.2 1 1.2.8 3.1-.5 4-.4.7-1 .9-1.6.9z",
    fill: "#ff681c"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    gradientUnits: "userSpaceOnUse",
    x1: 183.715,
    y1: 141.961,
    x2: 181.658,
    y2: 385.467
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#S",
    fill: "url(#G)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.1 276h-4.6l47.1-124.5c.3-.9 1.2-1.3 2-1.3 1.2 0 2.1 1 2.1 2.1 0 .3 0 .5-.1.8L101.1 276zm27.6 0H124l47.8-125.9h4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.3 169.7h-24.4l1.2-3.2h24.4zm-7.5 19.8h-24.4l1.2-3.2H158zm-7.5 19.8h-24.4l1.3-3.3h24.3zm-7.5 19.8h-24.3l1.2-3.3h24.4zm-7.5 19.7H110l1.2-3.2h24.4z"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    gradientUnits: "userSpaceOnUse",
    x1: 175.086,
    y1: 183.3,
    x2: 75.92,
    y2: 240.176
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M141.3 169.7l-6.2 16.5h23l-1.2 3.3h-23l-6.2 16.5h23l-1.2 3.3h-23l-6.2 16.5h23l-1.2 3.3h-23l-6.2 16.5h23l-1.2 3.3h-23L101.1 276h-4.6l47.1-124.5c.5-1.1 1.8-1.5 2.9-1.1.7.3 1.2 1.1 1.2 1.7 0 .3 0 .5-.1.8l-5.1 13.5h23l-1.2 3.3h-23z",
    fill: "url(#H)"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    gradientUnits: "userSpaceOnUse",
    x1: 178.416,
    y1: 196.86,
    x2: 4.487,
    y2: 296.606
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M128.7 276H124l47.8-125.9h4.6z",
    fill: "url(#I)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M357.1 168.3a5.45 5.45 0 01-2.4 1.2c-.8 0-1.6-.1-2.3-.4l-11.3-3.7c-1.8 1.3-2.2 3.9-1 5.8 1.2 1.2 2.6 2.1 4.1 2.5l7.8 2.8c3.6 1.7 7.9 1.6 11.4-.1 2.3-.8 4.9-1.7 6-3.9 1.2-2.2.3-5.1.7-7.6.4-1.6.8-3.3 1-4.9 0-1.4-1.2-3.6-2.9-3.3-1.4.3-2.5 2.8-3.3 3.9-2.1 2.8-4.7 5.5-7.8 7.7z",
    className: "b"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M339.7 164.7c-.1-.3-.3-.6-.6-.9a.96.96 0 00-.9-.2c-.3.2-.5.6-.5.9 0 .1 0 .3-.1.4s-.2 0-.4 0c-1.2-.3-2.6-.5-3.9-.6a.89.89 0 00-1 .6v.5c.1.5.4.9.7 1.2.7 1.1 1 2.5 2 3.3.7.4 1.4.6 2.1.5.8 0 1.4-.2 2.2-.1.5.1 1.1.1 1.4-.2s.6-.7.5-1.2c-.1-.7-.3-1.3-.7-1.9 0-.8-.4-1.6-.8-2.3zm31.7 85.3c-4.3-1-3.5 5.2-4.6 7.5-.8 1.2-1.6 2.2-2.7 3.1s-1.7 2.1-1.9 3.5c0 .3 0 .5.2.8s.6.5.9.5c2.5.8 5.2.5 7.4-.8 1.1-.5 1.9-1.3 2.6-2.4.5-1.2.7-2.3.7-3.6-.2-2.5.9-7.8-2.6-8.6z",
    className: "e"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M367.5 262.7s-12.4.6-7.1 4.4 13.1-1 13.8-1.8.1-2.4.1-2.4l-6.8-.2z",
    className: "a"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M373.7 264.4c-1.1 1.3-6.9 3.2-9.5 3s-4.9-1.3-4.6-3.1c.3-1.6 4.8-5.6 5.7-5.5s1.5 2 3.3 2.4c1.5.3 3.2-.3 4.2-1.5.3-.4.9-.6 1.3-.4.6 1.6.5 3.6-.4 5.1z",
    className: "b"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M386.2 252.4c-4.3-1.1-3.5 5.2-4.6 7.4-.8 1.2-1.6 2.2-2.7 3.1s-1.7 2.1-1.9 3.5c0 .3 0 .5.2.8s.6.5.9.5c2.5.7 5.2.5 7.4-.8 1.1-.5 1.9-1.3 2.6-2.4a8.75 8.75 0 00.7-3.5c-.1-2.5 1.1-7.8-2.6-8.6z",
    className: "e"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M382.4 265.1s-12.4.5-7.1 4.4 13.1-1 13.8-1.8.1-2.4.1-2.4l-6.8-.2z",
    className: "a"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M388.5 266.7c-1.1 1.3-6.9 3.2-9.5 3s-4.9-1.3-4.6-3.1c.3-1.6 4.8-5.6 5.7-5.5s1.5 2 3.3 2.4c1.5.3 3.2-.3 4.2-1.4.3-.4.9-.6 1.3-.4.7 1.6.5 3.5-.4 5z",
    className: "b"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375 196.3l5.8 61.1 8.4-1.1c3.3-14.9 2.5-59.5 2.5-59.5l-16.7-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.9 194.7l-5.8 61.1-8.4-1.1c-4.8-38.7-.9-62.7-.9-62.7l15.1 2.7z"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M366.6 172.6c-.1-1.2-.4-2.2-.5-3.4-.3-2.3-.2-4.6.1-6.9.4-2.4 1.2-4.8 2.2-7.1 1-1.9 2.7-2.7 4.7-3.7 1.6-.9 3.5-1.5 5.3-1.8 1.3-.1 2.6 0 3.8.2 3.9.8 9.1 2.7 11.8 5.9 2 2.3 2.3 5.7 2.3 8.7a137.52 137.52 0 01-.3 12.8c0 .6-.1 1.2-.1 1.8-.2 4.7-1 9.4-2.1 14-.2 1.4-1 2.7-2.2 3.6-3.1 1.8-7.8.8-11.1.4-4.4-.7-8.9-1.2-12.9-3.5-.8-.4-1.4-1-1.8-1.8-.2-1.1-.1-2 .4-3 1.3-4.3.3-8.9.3-13.4 0-.8.1-1.6.1-2.4v-.4z",
    className: "b"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    gradientUnits: "userSpaceOnUse",
    x1: 344.072,
    y1: 99.732,
    x2: 432.986,
    y2: 308.477
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M380.5 180.5c1.1.7 2.2 1.2 3.5 1.3 3.6 1.1 7.3 1.6 10.9 2.7.3 0 .5.2.7.3.2.2.2.5.2.8 0 1.1-.1 2.1-.5 3.1-.1.5-.4 1-.8 1.2a2.21 2.21 0 01-1.6 0l-13.5-2.9c-1-.3-1.9-.4-3-.4-1.2.1-2.3.4-3.5.9-2.1.7-4.2 1.2-6.3 1.3.1-2.6.4-5.2 1-7.7.2-.8.5-1.4.9-2.1.5-.7 1-1.3 1.5-1.8 2.2-2.3 3.6-5.1 5.9-7.4 1.2-1.2 2.6-1.9 3.6-3.3.4-.5 3.9-5 3.6-5.5.7.9 2.4 0 3 .9.4.6 0 1.2-.4 1.8-2.6 4.4-4.4 9.2-5.4 14.2-.4 1.4-.8 1.8.2 2.6z",
    fill: "url(#J)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M369.4 124.6c3.5 2.2 4.5 6.8 2.2 10.4-1.1 1.7-2.8 2.9-4.8 3.3 0 0-7.8 2.9-3.4 9.6l21.5 13.7-13.6 21.5c-6.7 4.3-9.6-3.4-9.6-3.4-.8-4-4.7-6.6-8.8-5.9-4 .8-6.6 4.7-5.9 8.8.8 4 4.7 6.6 8.8 5.9.1 0 .2 0 .3-.1 7.5-.2 7.2 7.3 7.2 7.3l-13.6 21.5-55.7-35.4 13.5-21.3c6.7-4.3 9.6 3.4 9.6 3.4.8 4 4.7 6.7 8.8 5.9 4-.8 6.7-4.7 5.9-8.8-.8-4-4.7-6.7-8.8-5.9-.1 0-.2.1-.4.1-7.5.2-7.2-7.3-7.2-7.3l13.8-21.7 21.5 13.7s7.5.3 7.3-7.2c-.5-2-.1-4.1 1-5.9 2.5-3.3 7-4.3 10.4-2.2z",
    className: "a"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M402.6 168.7c.6 1 1.1 2 1.3 3.1.5 1.8.5 3.8.1 5.7-.2 1.8-.9 3.6-1.9 5.1-2.3 2.7-6.4 3-10 2.7-4-.4-8.1-1.2-11.9-2.4-.4-.1-.7-.2-1-.5-.3-.4-.6-.8-.7-1.2-.3-1.2-.5-2.3-.6-3.5 4.1-1.2 8.6-.2 12.9-.9 1.1 0 1.8-.9 1.8-1.8 0-.2 0-.4-.1-.6-.2-2.4-1.7-4.5-2.4-6.8-.7-2.2-.6-4.6.2-6.8.5-1.5 1.6-2.9 3.1-3.5 1.7-.6 2.4.8 3.3 2 2.3 3 4.2 6 5.9 9.4z",
    className: "b"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M376.3 176.1l-.6-.3c-.3 0-.6.2-.8.6-.1.3-.3.6-.4.9-.4.5-1.1.7-1.6.7-.6-.1-1.2-.1-1.8 0-.2 0-.5.2-.6.3-.2.2-.3.4-.4.6-.2 1 .1 1.9.8 2.6s1.4 1.2 2.4 1.4c1 .4 1.9.6 3 .4.6-.2 1.1-.4 1.5-.7l2-1.1c.2-.1.3-.2.5-.3.5-.6-.2-2.2-.6-2.7-1-1.1-2.1-1.8-3.4-2.4zm-1.3-32.6c0-1.2.1-2.4.2-3.5.1-1.2.3-2 .5-3.1 0-.6.3-1.2.8-1.5 1.5-1 3.4-1.4 5.2-1.3a5.2 5.2 0 013.8 1.3c.6.8 1 1.7 1.1 2.7.1 2.6-.2 5.2-.8 7.7-.3 2-.4 3.9-.3 6a6.62 6.62 0 01-3.3 1.2c-.6 0-1.1-.1-1.5-.3-.3-.1-.6-.2-.7-.5-.1-.2-.1-.5 0-.7v-.7c.1-1.2.1-2.3-.1-3.5 0-.1 0-.2-.1-.3h-.6c-.6.1-1.2.1-1.7 0a3.1 3.1 0 01-1.8-.9c-.6-.6-.8-1.6-.7-2.6z",
    className: "e"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M377.5 136.1c-.4 0-.8.2-1.2 0-.4-.3-.7-.7-1-1.1-.7-.9-1-1.9-.9-3 0-.5.2-1 .5-1.3s.7-.7 1.2-.9c.9-.4 1.8-.6 2.7-.6 1.3.2 2.6.8 3.6 1.7.2.2.5.4.8.5s.6.1.8 0c1.7-.2 3.5.4 4.8 1.4.8.7 1.3 1.5 2.1 2.1s1.5.8 2 1.5c.4.7.3 1.5-.2 2.2-.5.6-1.2 1-2 1.2.4 1-.1 1.9-1.1 2.3-.3 0-.6.2-.9.3-.2.2-.3.4-.5.6-.5.4-1.1.5-1.2 1.2-.1.3-.1.6-.1.8 0 .4-.2.8-.5 1.1-.2.2-.5.7-.8.8s-.5-.3-.6-.6c-.3-1.2-.2-2.4.2-3.5.4-.6.6-1.2.6-1.7 0-.7-.9-1.2-1.3-.8-.5.4-.5 1.2-1 1.1.7-1.8-.2-3.8-1.9-4.7-1-.3-1.9-.4-2.9-.4-.2-.1-.7-.2-1.2-.2z",
    className: "d"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M379.2 147.2c1.3-.3 2.7-.7 3.9-1.2.2 2.2-1.2 4.3-3.3 5 .1-1.2.1-2.3 0-3.5 0-.1 0-.2-.1-.3h-.5z",
    fill: "#de9f93"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M336.6 157.1c.4.6.5 1.3.3 2s-.6 1.3-1.1 1.9l-2.1 3.2c-.6.9-1.3 1.7-2.3 1.6-2.3-.2-3.4-6.2-2.5-8.1 1-2.2 6.2-2.6 7.7-.6z",
    className: "e"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#T",
    className: "a"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    gradientUnits: "userSpaceOnUse",
    x1: 183.122,
    y1: 151.46,
    x2: 506.548,
    y2: 378.206
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#T",
    fill: "url(#K)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.6 178.4c0 4.1-3.4 7.5-7.5 7.5-2 0-3.9-.9-5.4-2.3-6.2-4.1-10 2.3-10 2.3v25.5h66v-66h-66v25.4c3.4 7.3 10 2.3 10 2.3 2.9-3 7.6-3.1 10.6-.2 1.4 1.5 2.3 3.5 2.3 5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.6 221.3c-3 2.9-3.1 7.6-.3 10.6 2.9 3 7.6 3.1 10.6.3 3-2.9 3.1-7.6.3-10.6l-.3-.3s-5-6.6 2.3-10h-15c0 .1 6.5 3.8 2.4 10z"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    gradientUnits: "userSpaceOnUse",
    x1: 223.674,
    y1: 312.678,
    x2: 284.68,
    y2: -15.354
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M215.7 145.5v25.4c3.4 7.3 10 2.3 10 2.3 2.9-3 7.6-3.1 10.6-.3 3 2.9 3.1 7.6.3 10.6s-7.6 3.1-10.6.3l-.3-.3c-6.2-4.1-10 2.3-10 2.3v25.5h25.4s6.4 3.7 2.3 10c-3 2.9-3.1 7.6-.3 10.6 2.9 3 7.6 3.1 10.6.3 3-2.9 3.1-7.6.3-10.6l-.3-.3s-5-6.6 2.3-10h25.5v-66l-65.8.2z",
    fill: "url(#L)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.7 211.4v66h66v-25.5s3.7-6.4 10-2.3c2.9 3 7.6 3.1 10.6.3s3.1-7.6.3-10.6c-2.9-3-7.6-3.1-10.6-.3l-.3.3s-6.6 5-10-2.3v-25.5h-25.4c-7.3 3.4-2.3 10-2.3 10 3 2.9 3.1 7.6.3 10.6s-7.6 3.1-10.6.3c-3-2.9-3.1-7.6-.3-10.6l.3-.3c4.1-6.2-2.3-10-2.3-10l-25.7-.1z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#S"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    gradientUnits: "userSpaceOnUse",
    x1: 186.397,
    y1: 88.368,
    x2: 177.185,
    y2: 493.526
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#S",
    fill: "url(#M)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M238.7 178.4c0 4.1-3.4 7.5-7.5 7.5-2 0-3.9-.9-5.4-2.3 0 0-6.6-5-10 2.3v25.5h-25.5c-7.3-3.4-2.3-10-2.3-10 3-2.9 3.1-7.6.3-10.6s-7.6-3.1-10.6-.3c-3 2.9-3.1 7.6-.3 10.6l.3.3c4.1 6.2-2.3 10-2.3 10H150v-66h25.2c7.3 3.4 2.3 10 2.3 10-3 2.9-3.1 7.6-.3 10.6 2.9 3 7.6 3.1 10.6.3 3-2.9 3.1-7.6.3-10.6l-.3-.3c-4.1-6.2 2.3-10 2.3-10h25.7v25.4s3.7 6.4 10 2.3c2.9-3 7.6-3.1 10.6-.2 1.5 1.5 2.3 3.5 2.3 5.5zm16.1 126.8c.1 4.1-3.3 7.5-7.4 7.6-2 0-4-.8-5.5-2.2 0 0-6.7-4.9-9.9 2.5l.4 25.5-25.5.4c-7.3-3.3-2.5-9.9-2.5-9.9 3-2.9 3-7.6.1-10.6s-7.6-3-10.6-.1-3 7.6-.1 10.6l.2.2c4.2 6.1-2.2 10-2.2 10l-25.5.4-1-66 25.2-.4c7.3 3.3 2.5 9.9 2.5 9.9-3 2.9-3 7.6-.1 10.6s7.6 3 10.6.1 3-7.6.1-10.6l-.2-.2c-4.2-6.1 2.2-10 2.2-10l25.7-.4.4 25.5s3.8 6.4 10 2.2c1.4-1.5 3.4-2.4 5.5-2.4 4.2-.2 7.6 3.2 7.6 7.3z",
    className: "a"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    gradientUnits: "userSpaceOnUse",
    x1: 149.544,
    y1: 259.281,
    x2: 268.872,
    y2: 388.965
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M174.8 273.7c-1 1.1-1.6 3.3-.2 4.1.5.3 1.1.5 1.6.5l7.7 1c-.2 0 3.8 45.4 5.4 55.1.2 1.2.7 2.6 1.8 2.7.7 0 1.3-.4 1.7-1.1 1.2-1.7 1.7-3.7 1.8-5.9 1.9-14.9 2.8-29.8 2.7-44.7 0-3-.1-6-1.5-8.6-1.8-2.9-4.8-4.8-8.1-5.4-4.2-.9-9.7-1.2-12.9 2.3z",
    fill: "url(#N)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M193.4 368v.2c.3.9 1.3 1.1 2.2 1.2s1.6.1 2.5.1c.4 0 .8 0 1.2-.2s.7-.4 1-.6l2.4-1.7c.7-.5 1.2-1 1.8-1.6s.9-1.4.8-2.2c-.1-.9-.7-1.5-1.4-1.7-.5-.1-1-.1-1.5 0-1.2.2-2.2-.4-2.9-1.3-.1-.5-.4-.9-.7-1.2-.4-.2-.8-.2-1.2-.1-.9 0-1.6.2-2.4.5s-1.4 1-1.7 1.7c-.1.4-.1.8-.1 1.2v2.3l-.2 2.9c.1 0 .1.3.2.5zm23.1.4c-1.6.8-3.3 1.3-5 1.9-.7.3-1.4.3-2.1.1-.6-.3-1-.8-1.2-1.3-.2-.6-.2-1.2-.2-1.8a12.66 12.66 0 01.6-2.8c.2-.9.3-1.7.4-2.6l.5-3.6 4.3 1c.5.1.9 1.8 1.2 2.2.4.6 1.1.9 1.7 1 .8-.1 1.4-.2 2.2-.2 1 .2 1.7 1.1 1.7 2.1s-.4 1.9-1.2 2.6-1.5 1.2-2.5 1.5l-.4-.1z",
    fill: "#262836"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#U",
    className: "a"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    gradientUnits: "userSpaceOnUse",
    x1: 175.129,
    y1: 288.701,
    x2: 243.452,
    y2: 384.346
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#U",
    fill: "url(#O)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M252.9 255.1c.1-.1.2-.1.3-.1.3 0 .3.5.2.8-.3.9-.7 1.6-1.2 2.3-.2.2-.3.4-.3.7s.2.4.4.6c1.1 1.2 1.4 2.8 1.1 4.3-.4 1.5-1.2 2.9-2.2 3.9-.6.7-1.3 1.2-2.2 1.2-1.4 0-3.3-1.8-3.9-3.1-.5-1.2-.2-2.7.7-3.7 1.6-2.9 4.1-5.3 7.1-6.9zm-42.7-14.3c.5.5 1.2 1 1.1 1.6-.1.4-.5.6-.8.8a3.69 3.69 0 00-1.1 2.7c0 1-.1 1.9-.4 2.9-.4 1-1.3 1.5-2.3 1.3-.6-.2-1.2-.7-1.6-.4-.6.2-.6.7-.8 1.1-.6 1-1.7 1.4-2.9 1.3-1.1-.2-2.1-.6-3.1-1.1a4.44 4.44 0 01-1.1-.8c-.2-.4-.2-.8-.1-1.1.4-1.2.9-2.1 1.6-3.1 1.2-1.8 1.9-3.8 2-6 .1-1.5 0-3.2 1-4.3 1.3-1.5 4.4-1.5 6-.4 1.8 1.2.9 3.9 2.5 5.5z",
    fill: "#a67c52"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M208.2 234c-.2.4-.5.7-.9 1-.8.4-1.3 1-2 1.3-.7.5-1.2 1.2-1.2 1.9-.3 1.3.5 2.9 0 4.3-.2.3-.7.1-.8-.2-.2-.3-.3-.6-.6-.8-.5-.3-1.1.2-1.2.7-.5 1.2.2 2.6 1.3 3.1-.1.5-.7.6-1.1.6-.5-.1-.9-.2-1.3-.2-1.1.2-1.3 1.6-2.4 1.8-.7 0-1.3-.4-1.7-1.1l-1.2-1.3c-.2-.3-.4-.5-.7-.8-.3-.2-.8-.2-1-.5s0-.9-.3-1.2c-.1-.1-.3-.2-.4-.3-.8-.4-1.2-1.2-.9-2v-.3c0-.1-.2-.2-.3-.3-.8-.5-1.1-1.5-.7-2.3a2.73 2.73 0 01.9-1.2c.3-.4.8-.7 1.2-.6l.2-1.8c0-1.2.9-2 2-2.1h.4l-.4-1.4c-.1-.2-.1-.4 0-.6.1-.1.3-.2.5-.3l1.4-.3c-.2-.4-.3-.9-.4-1.2-.1-.2 0-.4.2-.5.1 0 .2-.1.3 0h.6l-.3-1.3c-.1-.4 0-.8.2-1.2.3-.4.8-.5 1.2-.5.5.1.9.2 1.2.5 0-.5.6-.8 1.1-.8 1.8-.1 3.6.8 4.7 2.3.1.1.2.3.3.4.2.1.5.3.7.3.8.4 1.3 1.1 1.6 1.8.2.8.3 1.6.3 2.5 0 .7 0 1.2-.2 1.9-.2.3-.3.5-.3.7z",
    fill: "#2f3554"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.4 249.4c1.2.5 2.2 1.1 3.3 1.6.3.2.6.4.9.8.2.3.3.8.1 1.2-.3.5-1 .3-1.4.1-2.4-.8-4.9-1.2-7.5-1.1-.4.1-.7-.1-.9-.4-.1-.4-.1-.7.1-1.1 1.2-2.4 3.3-2 5.4-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.1 269.5c-.5 1.2-1.2 2.3-2.1 3.3l-2.7 2.9c-2.2 2.2-4.6 4.2-7.1 6-1.6 1.4-3.6 2.6-5.9 3.2-.9.2-1.8.2-2.7-.2-.7-.4-1.3-.8-1.8-1.3-.7-.7-7.9-9-8.1-9-.4.2-.8.6-.9 1.1-1.1 2.2-1.7 4.5-1.9 6.9-.1 1.1-.1 2.1 0 3.3.3 3.6 1.5 7.4.3 10.9-.3.8-.7 1.4-1.2 1.9-.6.5-1.2.9-1.8 1.1-1.2.5-2.4.9-3.6 1.1-.7.1-1.4.2-2.2.2-2.7.1-5.3-.4-8-.3-2.3.1-4.5.7-6.8.7-1.2.3-2.4-.6-2.7-1.8v-.4c-.9-4.9-1.3-9.8-1.3-14.7 0-1.7-.1-3.5-.2-5.2-.1-1.4.3-5.2-1.3-5.5-4.2-.9-8.6.2-12.9-.4.1-2.8 1.3-5.5 3.3-7.4 1-.9 2-1.5 3.2-2.2 1.3-1 2.5-2 3.5-3.3 2.9-3.6 6.5-6.4 10.8-8.4.7-.3 1.3-.6 2.1-.8h.5c.9-.1 1.8 0 2.7.2 6 1.1 12.1 2.4 18 4.1.8.2 1.5.5 2.2 1 .5.4.9.9 1.2 1.4l5 7.6c1.4 2.1 2.9 4.9 5 6.4 4.6-1.9 9-4.3 13-7.3.6-.4 1.2-.9 1.9-.6.2.1.4.2.6.4 1.3 1.3 2.7 2.8 1.9 5.1z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "Q",
    d: "M152.8 88.5c4 2.7 8.5 4.5 13.3 5.5.2 0 .5.1.5.4 0 .1 0 .3-.1.4a31.72 31.72 0 01-3.6 5.4c-.2.2-.4.4-.6.5-.5.1-1 .1-1.3-.2-3.1-1.2-6-2.6-9-4.1a21.05 21.05 0 01-6.8-5c-1-1.2-1.5-2.5-1.5-3.9 0-1.6 1.4-4.5 3.5-3.7 1 .4 1.7 1.4 2.4 2.1.9.9 2.1 1.8 3.2 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R",
    d: "M209.9 80.4c2 2.5 1.5 6.2-1 8.2-1.2 1-2.9 1.4-4.5 1.2 0 0-6.4.2-5 6.2l12.3 15.6-15.6 12.3c-6 1.4-6.2-5-6.2-5 .5-3.2-1.7-6.1-5-6.6-3.2-.5-6.1 1.7-6.6 5s1.7 6.1 5 6.6h.3c5.6 1.8 3.4 7.2 3.4 7.2l-15.6 12.3-32-40.4 15.5-12.3c6-1.4 6.2 5 6.2 5-.5 3.2 1.7 6.1 4.9 6.6s6.1-1.7 6.6-4.9c.3-1.6-.2-3.2-1.2-4.5-1-1.2-2.5-2-4.1-2.2-5.5-1.8-3.4-7.3-3.4-7.3L179.7 71 192 86.6s5.5 2.1 7.2-3.4c.3-3.2 3.2-5.6 6.4-5.2 1.9.3 3.3 1.1 4.3 2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "S",
    d: "M149.9 277.4v-25.5c3.4-7.3 10-2.3 10-2.3 2.9 3 7.6 3.1 10.6.3s3.1-7.6.3-10.6c-2.9-3-7.6-3.1-10.6-.3l-.3.3c-6.2 4.1-10-2.3-10-2.3v-25.5h25.5s6.4-3.7 2.3-10c-3-2.9-3.1-7.6-.3-10.6 2.9-3 7.6-3.1 10.6-.3 3 2.9 3.1 7.6.3 10.6l-.3.3s-5 6.6 2.3 10h25.5v66l-65.9-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "T",
    d: "M347.6 211.4v66h-66v-25.5s3.7-6.4 10-2.3c2.9 3 7.6 3.1 10.6.3 3-2.9 3.1-7.6.3-10.6-2.9-3-7.6-3.1-10.6-.3l-.3.3s-6.6 5-10-2.3v-25.5h25.5c7.3-3.4 2.3-10 2.3-10-3-2.9-3.1-7.6-.3-10.6 2.9-3 7.6-3.1 10.6-.3 3 2.9 3.1 7.6.3 10.6l-.3.3c-4.1 6.2 2.3 10 2.3 10l25.6-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U",
    d: "M216.5 363.6c-1.2.7-2.3 1.2-3.5 1.6h-.1c-2 .8-4.2-2.3-4.2-2.3s-2.8-17.4-2.7-24.5c.1-4.9-1.1-12-2.9-24.7-.5 13.1-2.7 18.7-2.1 23.4.9 7.1-.2 24.8-.2 24.8s-1.9 3.5-3.9 3h-.1c-1.2-.3-2.5-.7-3.6-1.2 0 0-2.4-24.3-2.4-30.7s.3-12.1.3-12.1l-1.2-20.3 5.4-7.8.5-.2.4-.4 6-4.3s0 1.1-.1 2.7l4.6 2.5.5.3.5.1 7.7 1.3 2.7 37.4c.4 6.4-1.6 31.4-1.6 31.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanding);
export default __webpack_public_path__ + "static/media/landing.ecbb78dab28a91de0530fd8cb77d376b.svg";
export { ForwardRef as ReactComponent };